module.exports = __webpack_public_path__ + "img/AutoBtn.86242cb9.svg";